import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useParcelJoin = () => {
    const send = useGenericSend();

    return useCallback(async ({ mysteryParcelId }: Types.IParcelJoinRequestData) => {
        const response = await send<Types.IParcelJoinRequestData>({
            ID: 73050,
            mysteryParcelId,
            responses: [73051, 73052],
            description: 'Mystery Parcel join request'
        });

        return response;
    }, [send]);
};
